import InfoOutlined from '@mui/icons-material/InfoOutlined'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material'
import { type FC, useState } from 'react'

type Props = {
  name: string
  onDelete: () => void
}

export const DeleteConfirmButton: FC<Props> = ({ name, onDelete }) => {
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)

  return (
    <>
      <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
        <DialogContent sx={{ p: 4 }}>
          <Stack direction="row" alignItems="center" gap={1}>
            <InfoOutlined sx={{ color: 'warning.main' }} />
            <Typography fontWeight="bold" variant="h6" color="text.primary">
              この{name}を削除しますか？
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={close}>
            キャンセル
          </Button>
          <Button
            variant="text"
            color="error"
            onClick={() => {
              onDelete()
              close()
            }}
          >
            削除
          </Button>
        </DialogActions>
      </Dialog>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        <Typography
          variant="body2"
          color="error"
          fontWeight="500"
          textAlign="left"
        >
          削除
        </Typography>
      </button>
    </>
  )
}
